<template>
    <div>
        <div>
            <div class="app-address-info">
                <div>
                    <div class="app-input-address">
                        <div class="app-user-address">
                            <label :for="'addressline1' + addressDetails.addressCategoryId" class="sr-only">
                                Address line 1
                            </label>
                            <input type="text" :id="'addressline1' + addressDetails.addressCategoryId" class="user-address-info" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddress1 ? 'orange-bg' : '']"
                            v-model="physicalAddress1" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                        </div>
                        <div class="app-user-address">
                            <label :for="'addressline2' + addressDetails.addressCategoryId" class="sr-only">
                                Address line 2
                            </label>
                            <input type="text" :id="'addressline2' + addressDetails.addressCategoryId" class="user-address-info" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddress2 ? 'orange-bg' : '']"
                             v-model="physicalAddress2" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                        </div>
                        <div class="app-user-address">
                            <label :for="'city' + addressDetails.addressCategoryId" class="sr-only">
                                City
                            </label>
                            <input type="text" :id="'city' + addressDetails.addressCategoryId" class="user-address-info-city" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddressCity ? 'orange-bg' : '']"
                             v-model="physicalAddressCity" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                        </div>
                        <div class="app-user-address-info">
                            <div class="app-user-address">
                                <label :for="'state' + addressDetails.addressCategoryId" class="sr-only">
                                    State
                                </label>
                                <select class="app-custom-select" :id="'state' + addressDetails.addressCategoryId" aria-required="true" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddressState ? 'orange-bg' : '']"
                                    v-model="physicalAddressState" @focusout="checkMailingAddress" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                                    <option v-for="(type) in usStates" :value="type.stateId" :key="type.code">
                                        {{ type.code }} - {{ type.description }}
                                    </option>
                                </select>
                            </div>
                            <div class="app-user-address">
                                <label :for="'zipcode' + addressDetails.addressCategoryId" class="sr-only">
                                    Zipcode
                                </label>
                                <input type="text" :id="'zipcode' + addressDetails.addressCategoryId" class="zip-selection" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddressZipcode ? 'orange-bg' : '']"
                                v-model="physicalAddressZip" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                                <div class="diff">
                                    -
                                </div>
                                <div>
                                    <label :for="'zipplus' + addressDetails.addressCategoryId" class="sr-only">
                                        Zipplus
                                    </label>
                                    <input type="text" :id="'zipplus' + addressDetails.addressCategoryId" class="user-address-info-zipplus" :class="[{ 'user-address-info-gray': physicalMailingAddressCheck }, !userAddressZipplus ? 'orange-bg' : '']" 
                                    maxlength="4" v-model="physicalAddressZipPlus" :readonly="physicalMailingAddressCheck" :disabled="physicalMailingAddressCheck">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'ConfirmAddress',
    components: {
    },
    data() {
        return {
            physicalAddress1: '',
            physicalAddress2: '',
            physicalAddressCity: '',
            physicalAddressState: '',
            physicalAddressZip: '',
            physicalAddressZipPlus: '',

            mailingAddress1:'',
            mailingAddress2: '',
            mailingAddressCity: '',
            mailingAddressState: '',
            mailingAddressZip: '',
            mailingAddressZipPlus: '',

            physicalMailingAddressCheck: true,

            physicalAdress1ErrMsg: '',
            physicalAdressCityErrMsg: '',
            physicalAdressStateErrMsg: '',
            physicalAdressZipErrMsg: '',

            mailingAdress1ErrMsg: '',
            mailingAdressCityErrMsg: '',
            mailingAdressStateErrMsg: '',
            mailingAdressZipErrMsg: ''
        }
    },
    props: {
        addressDetails: null
    },
    computed: {
        ...mapGetters({
            personalInfo: COMMONS.GUEST_PERSONAL_INFO,
            addressLookupInfo: COMMONS.GUEST_ADDRESS_LOOKUP_INFO 
        }),
        
        usStates() {
            return this.addressLookupInfo.allUsStates;
        },
        instateZipCodes() {
            return this.addressLookupInfo.allInstateZipcodes;
        },
        userPhysicalAddress() {
            return this.$store.state.guestLogin.userPhysicalAddress;
        },
        userMailingAddress() {
            return this.$store.state.guestLogin.userMailingAddress;
        },
        userAddress1() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.addressLine1.toUpperCase() == this.userPhysicalAddress.addressLine1.toUpperCase();
                }
                else {
                    return this.addressDetails.addressLine1.toUpperCase() == this.userMailingAddress.addressLine1.toUpperCase();
                }
            }
        },
        userAddress2() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.addressLine2.toUpperCase() == this.userPhysicalAddress.addressLine2.toUpperCase();
                }
                else {
                    return this.addressDetails.addressLine2.toUpperCase() == this.userMailingAddress.addressLine2.toUpperCase();
                }
            }
        },
        userAddressCity() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.city.toUpperCase() == this.userPhysicalAddress.city.toUpperCase();
                }
                else {
                    return this.addressDetails.city.toUpperCase() == this.userMailingAddress.city.toUpperCase();
                }
            }
        },
        userAddressState() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.stateId == this.userPhysicalAddress.stateId;
                }
                else {
                    return this.addressDetails.stateId == this.userMailingAddress.stateId;
                }
            }
        },
        userAddressZipcode() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.zipCode == this.userPhysicalAddress.zipCode;
                }
                else {
                    return this.addressDetails.zipCode == this.userMailingAddress.zipCode;
                }
            }
        },
        userAddressZipplus() {
            if(this.$store.state.guestLogin.addressUpdateStep != 2) {
                return true;
            }
            else {
                if(this.addressDetails.addressCategoryId == 1) {
                    return this.addressDetails.zipPlus == this.userPhysicalAddress.zipPlus;
                }
                else {
                    return this.addressDetails.zipPlus == this.userMailingAddress.zipPlus;
                }
            }
        },
    },
    created() {

    },

    watch: {
        addressDetails: {
            handler(newVal) {
                console.log('HANDLER IS', newVal)

                if(this.addressDetails!=null) {
                    this.physicalAddress1 = this.addressDetails.addressLine1;
                    this.physicalAddress2 = this.addressDetails.addressLine2;
                    this.physicalAddressCity = this.addressDetails.city;
                    this.physicalAddressState = this.addressDetails.stateId;
                    this.physicalAddressZip = this.addressDetails.zipCode;
                    this.physicalAddressZipPlus = this.addressDetails.zipPlus;

                    // this.mailingAddress1 = this.addressDetails.addressLine1;
                    // this.mailingAddress2 = this.addressDetails.addressLine2;
                    // this.mailingAddressCity = this.addressDetails.city;
                    // this.mailingAddressState = this.addressDetails.stateId;
                    // this.mailingAddressZip = this.addressDetails.zipCode;
                    // this.mailingAddressZipPlus = this.addressDetails.zipPlus;
                }
                else {
                    console.log('this')
                }
            },
            deep: true
        }
    },
    mounted() {
        window.scroll(0,0);
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;

        if(this.addressDetails!=null) {
            this.physicalAddress1 = this.addressDetails.addressLine1;
            this.physicalAddress2 = this.addressDetails.addressLine2;
            this.physicalAddressCity = this.addressDetails.city;
            this.physicalAddressState = this.addressDetails.stateId;
            this.physicalAddressZip = this.addressDetails.zipCode;
            this.physicalAddressZipPlus = this.addressDetails.zipPlus;

            // this.mailingAddress1 = this.addressDetails.addressLine1;
            // this.mailingAddress2 = this.addressDetails.addressLine2;
            // this.mailingAddressCity = this.addressDetails.city;
            // this.mailingAddressState = this.addressDetails.stateId;
            // this.mailingAddressZip = this.addressDetails.zipCode;
            // this.mailingAddressZipPlus = this.addressDetails.zipPlus;
        }
    },
    methods: {
        ...mapActions({
            getUpdateAddress: COMMONS.GUEST_UPDATE_ADDRESS
        }),
        async handleRouting(info) {
            if(info=='previous') {
                this.$store.state.guestLogin.addressUpdateStep = 2;
            }
            else if (info=='next') {
                this.$router.push({ path : '/profile' });
            }
        },
        checkMailingAddress() {
            if(this.physicalMailingAddressCheck) {
                this.mailingAddress1 = this.physicalAddress1;
                this.mailingAddress2 = this.physicalAddress2;
                this.mailingAddressCity = this.physicalAddressCity;
                this.mailingAddressState = this.physicalAddressState;
                this.mailingAddressZip = this.physicalAddressZip;
            }
        }
    }
}
</script>


<style scoped lang="scss">

.app-address-info{
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
  .app-input-address{
    display: block;
    .app-user-address-info{
      display: flex;
      gap: 2rem;
    }
    .app-user-address{
      margin-bottom: 1rem;
      display: flex;
      .user-address-info{
        min-width: 275px;
        width: 100%;
      }
      .diff{
        padding: 0.5rem;
      }
      .zip-selection {
        width: 106px !important;
      }
      .user-address-info-zipplus {
        max-width: 100px;
      }
      .user-address-info-gray{
        background: lightgray;
      }
    }
  }
}
.orange-bg {
    background-color: orange !important;
}
.voter-reg {
    label {
        display: block;
        margin-left: 1rem;
    }
    input {
        float: left;
        height: 20px;  
    }
}

@media only screen and (max-width: 510px) {
  .app-address-info{
    .app-input-address{
      display: block;
      .app-user-address-info{
        display: block;
      }
      .app-user-address{
        .user-address-info{
          min-width: 300px;
        }
        .user-address-info-city {
          width: 200px;
        }
        .zip-selection {
          width: 106px !important;
        }
        .user-address-info-zipplus {
          max-width: 100px;
        }
      }
    }
  }
}
</style>